import React, { useCallback, useEffect, useImperativeHandle, useState } from "react";
import { IntegrationEntity, connectionProfileType, inputType, mediaType } from "../../types/types";
import { Box, Button, Divider, Grid, IconButton, MenuItem, Modal, Stack, TextField, Typography } from "@mui/material";
import { GenericInput } from "../../components/inputs/GenericInput";
import { useDispatch, useSelector } from "react-redux";
import { IntegrationActions } from "../../stateManagement/actions/integrationDashboardActions";
import { Trash } from "tabler-icons-react";
import { getMediaOutProfiles, getProfileByName, updateMediaProfiles } from "../../services/integrationService";
import { InterlinkedInputs } from "./exportExceptionComponents";
import { popupType } from "../../types/types"
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

type ProfileModalState = 'new'|'edit'|'close'

export default function ExportExceptionFilePage(props:{
  decrement: ()=>void;
  increment: ()=>void;
  integrationEntityList:IntegrationEntity[];
  mediaProfileConfigList:mediaType[];
}){
    const profileRef = React.useRef<any>();
    const mappingRef = React.useRef<any>();

    const updateStore = ()=>{
      profileRef.current.updateStore();
      mappingRef.current.updateStore(); 
    }
    
    return (<Stack padding={4} spacing={4}>
        <ExportExceptionConfig ref={profileRef} mediaProfileConfigList={props.mediaProfileConfigList}/>
        <Divider/>
        <EntityFileMappingInfo ref={mappingRef} integrationEntities={props.integrationEntityList}/>
        <Box display="flex" width={"100%"} padding={"20px 0 0 0"}>
          <Button key="previous" className="navigation-btn bottom-bar-navigation-btn" onClick={props.decrement} variant="contained">Previous</Button>
          <Button key="next" className="navigation-btn bottom-bar-navigation-btn" onClick={()=>{updateStore(); props.increment();}} variant="contained">Next</Button>
        </Box>
    </Stack>)
}

// --------------- EntityFileMappingInfo -----------------------------

const EntityFileMappingInfo = React.forwardRef(function (props:{
    integrationEntities:IntegrationEntity[],
},ref){

  const entityList = props.integrationEntities.map(s=>s.entityName);

  const initialEntityMapping = useSelector((state: any) => state.integrationRegistry.entityFileNameMapping);

  const [dateFormat, setDateFormat] = useState<string>("yyyyMMdd_HHmmss");
  const dateObj = `{"dateFormat" : "${dateFormat}"}`;
  const defaultEntityMapping: inputType = {
    key: "dateFormat",
    value: dateFormat,
  };
  const [entityMapping, setEntityMapping] = useState<inputType[]>([defaultEntityMapping]);

  const updateDateFormat = ( event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> ) => {
    setDateFormat(event.target.value);
    const newList = [...entityMapping];
    const idx = newList.findIndex((element) => element.key === "dateFormat");
    if (idx === -1) {
        const dateFormatInput: inputType = {
        key: "dateFormat",
        value: event.target.value,
      };
      newList.push(dateFormatInput);
    } else {
      newList[idx].value = event.target.value;
    }
    setEntityMapping(newList);
  };

  useEffect(() => {
    const initialMappingList: inputType[] = [];
    const entityMappingObject: { [key: string]: string } = JSON.parse(initialEntityMapping=== "" ? dateObj :initialEntityMapping);
    Object.entries(entityMappingObject).forEach((element) => {
      const inputObject: inputType = {
        key: element[0],
        value: element[1],
      };
      initialMappingList.push(inputObject);
    });
    const dateVal = initialMappingList.filter((initialMappingObject) => initialMappingObject.key === "dateFormat").length > 0 ? initialMappingList.filter((initialMappingObject) => initialMappingObject.key === "dateFormat")[0].value : dateFormat;
    setEntityMapping(initialMappingList);
    setDateFormat(dateVal);
  }, [initialEntityMapping])
  
  const dispatch = useDispatch();
  
  useImperativeHandle(ref, () => ({
    updateStore(){
      const outProfileAttributes : any = {};
      entityMapping.forEach((input) =>{
        outProfileAttributes[input.key] = input.value;
      });
      const objString = JSON.stringify(outProfileAttributes);
      dispatch(IntegrationActions.setEntityFileMapping(objString));
    }
  }));

  return (<>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between">
        <Typography variant="h6" width={"100%"}>File Date Format</Typography>
        <TextField
          label="Date Format"
          defaultValue={dateFormat}
          onChange={updateDateFormat}>
        </TextField>
    </Box>
    <Divider/>
    <Box> 
      <Typography variant="h5" fontWeight={"bold"}>Entity File Mapping</Typography>
      <InterlinkedInputs
        entityList={entityList}
        exisitingMappingList={entityMapping}
        setMapping={setEntityMapping} 
      />
    </Box>
    
  </>)
})


// ------------------------ExportExceptionConfig-----------------------------

const ExportExceptionConfig = React.forwardRef (function (props:{
    mediaProfileConfigList:mediaType[],
 }, ref) {

  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    updateStore() {
      dispatch(IntegrationActions.setOutProfileName(profileName));    
    }
  }));
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");

  const openPopup = (message: string, type: popupType) => {
      setPopupType(type)
      setGenericMessage(message)
      setOpenGenericModal(true)
  }
  
  const selectedOutProfileName: string = useSelector((state: any) => state.integrationRegistry.outProfileName);// schedule out-profile name

  const authContext = JSON.parse(localStorage.authContext)
  const [mediaOutProfiles,setMediaOutProfiles] = useState<connectionProfileType[]>([]); // media profile List
  const [mediaType,setMediaType] = useState<string>("--none--"); // first select
  const [profileName,setProfileName] = useState<string>(""); // second select
  const selectedMediaOutProfile = mediaOutProfiles.find((profile)=>profile.name===profileName) // selected profile from profile List

  const fetchMediaOutProfiles = useCallback(async () => {
    const res = await getMediaOutProfiles(authContext.user.lob,props.mediaProfileConfigList.map((mediaType) => mediaType.type).join(","))
    setMediaOutProfiles(res);
    return res;
  },[authContext.user.lob, props.mediaProfileConfigList])

  useEffect(() => {
    fetchMediaOutProfiles().then((outProfiles:connectionProfileType[]) => {
      const selected = outProfiles.find((profile)=>profile.name===selectedOutProfileName);
      if(selected) {
        setProfileName(selected.name);
        setMediaType(selected.type);
      }
    });
  }, [fetchMediaOutProfiles, selectedOutProfileName])  

  const [profileModalState,setProfileModalState] = useState<ProfileModalState>('close');
  const profileModalOpen = profileModalState ==='new' || profileModalState==='edit';
  return (
    <Grid container spacing={2}>
      <GenericPopUp message={genericMessage}
          type={popupType}
          openGenericModal={openGenericModal}
          setOpenGenericModal={() => setOpenGenericModal(false)}
      />
      <Grid item xs={12} sm={6} md>
        <GenericInput
          textFieldInputProps={{
            select: true,
            fullWidth: true,
            label: "Profile Type",
            value: mediaType,
            children: [
              <MenuItem key={"--none--"} value={"--none--"}>
                {"--none--"}
              </MenuItem>,
              ...props.mediaProfileConfigList.map((mediaType) => (
                <MenuItem key={mediaType.type} value={mediaType.type}>
                  {mediaType.displayName} ({mediaType.type})
                </MenuItem>
              )),
            ],
            onChange: (e) => {
              setMediaType(e.target.value);
              setProfileName("");
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md>
        <GenericInput
          textFieldInputProps={{
            disabled: mediaType === "--none--",
            select: true,
            fullWidth: true,
            label: "Profile Name",
            value: profileName,
            children: mediaOutProfiles
              .filter((profile) => profile.type === mediaType)
              .map((profile) => (
                <MenuItem key={profile.name} value={profile.name}>
                  {profile.name}
                </MenuItem>
              )),
            onChange: (e) => setProfileName(e.target.value),
          }}
        />
      </Grid>
      <Grid item display={"flex"} alignItems={"center"} gap={2}>
        <Button variant="contained" className="navigation-btn"
          onClick={() => { selectedMediaOutProfile
              ? setProfileModalState("edit")
              : openPopup("Please Select Profile to edit",'Alert');
          }}
        >Edit</Button>
        <Button variant="contained" className="navigation-btn"
          onClick={() => { mediaType !== "--none--"
            ? setProfileModalState("new")
            : openPopup("Please Select Profile Type",'Alert');
          }}
        >Create</Button>
      </Grid>
      {profileModalOpen && 
        <ProfileModal key={selectedMediaOutProfile?.name || "new"}
          open={profileModalOpen}
          mediaProfileConfig={props.mediaProfileConfigList.find((config)=>config.type===mediaType)||{type:"",attributes:[]} as mediaType}
          // setMediaOutProfiles={setMediaOutProfiles}
          modalState={profileModalState}
          selectedMediaOutProfile={selectedMediaOutProfile}
          onClose={() =>{setProfileModalState("close"); fetchMediaOutProfiles();}}
        />
      }
    </Grid>
  );
})

// ------------------------ProfileModal-----------------------------

function ProfileModal(props:{
    open:boolean,
    mediaProfileConfig:mediaType,
    selectedMediaOutProfile?:connectionProfileType,
    modalState:ProfileModalState,
    onClose:()=>void,
}){
    const [profileName,setProfileName] = useState<string>(props.modalState === 'edit' ? props.selectedMediaOutProfile?.name || "" : ""); // new | edit
    const [attributes,setAttributes] = useState<any>(
      props.modalState === 'new' ? props.mediaProfileConfig.attributes : props.selectedMediaOutProfile?.attributes
    );

    const [saving,setSaving] = useState<boolean>(false);
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");

    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }

    const handleChangeKey = (oldKey:string,newKey:string) => {
      if(newKey === "") {
        handleDeleteKey(oldKey);
        return;
      }
      if(attributes[newKey] !== undefined) { 
        openPopup("Key Already Exists!",'Alert');
        return;
      }
      const newAttributes:any = {};
      Object.keys(attributes).forEach((attributeKey:string)=>{
        if(attributeKey === oldKey) newAttributes[newKey] = attributes[oldKey];
        else newAttributes[attributeKey] = attributes[attributeKey];
      })
      setAttributes(newAttributes);
    }
    const handleChangeValue = (key:string,value:string|boolean) => {
      const newAttributes = {...attributes};
      newAttributes[key] = value;
      setAttributes(newAttributes);
    }
    const handleDeleteKey = (key:string) => {
      const newAttributes = {...attributes};
      delete newAttributes[key];
      setAttributes(newAttributes);
    }
    const handleAddRow = () => {
      const newAttributes = {...attributes};
      if(newAttributes[""] === undefined){
        newAttributes[""] = "";
        setAttributes(newAttributes);
      }
      else openPopup("Row Already Exists!",'Alert');
    }
    const handleSave = async () => {
      if(saving) return;
      setSaving(true);
      if(profileName === "") {
        openPopup("Profile Name Cannot be Empty!",'Alert');
        setSaving(false);
        return;
      }
      if(Object.keys(attributes).length === 0) {
        openPopup("Profile Attributes Cannot be Empty!",'Alert');
        setSaving(false);
        return;
      }
      if(Object.values(attributes).indexOf('') !== -1) {
        openPopup("Profile Attributes Cannot be Empty!",'Alert');
        setSaving(false);
        return;
      }
      const newProfile:connectionProfileType = {
        name: profileName,
        type: props.mediaProfileConfig.type,
        attributes: attributes,
        lob: JSON.parse(localStorage.authContext).user.lob,
      }
      if(props.modalState === 'edit') {
        newProfile.id = props.selectedMediaOutProfile?.id || "";
      }
      if(props.modalState === 'new') {
        const existingProfile = await getProfileByName(profileName);
        if(existingProfile.status === 200){
          openPopup(`A profile with the same name already exists, please enter a different name.`, "Error")
          setSaving(false);
          return;
        }
      }
      await submitProfile(newProfile);
      setSaving(false);
    }
    const submitProfile = async (profile: connectionProfileType) => {
      const response = await updateMediaProfiles(
        JSON.parse(localStorage.authContext).user.lob, 
        profile,
        props.modalState === 'new'
      );
      if (response.status === 'Success'){
          openPopup("Successfully Saved",'Success')
      }else{
          openPopup("Internal Server Error",'Error')
      }
    }
    return (
      <Modal
          style={{zIndex:10}}
          open={props.open}
          onClose={props.onClose}
      >
          <Box sx={{
              position: "absolute" as "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "75%",
              maxHeight: "75%",
              overflowY: "auto",
              bgcolor: "background.paper",
              borderRadius: "0.5rem",
              boxShadow: 24,
              p: "2rem",
          }}>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={() =>{ setOpenGenericModal(false); if(popupType === "Success") props.onClose();}}
            />
            <h3>{props.modalState === 'new' ? "Create" : "Edit"} Profile</h3>
            <IconButton style={{position:"absolute", right:"20px", top:"10px"}} onClick={props.onClose}><FontAwesomeIcon icon={faXmark}/></IconButton>
            <Box display="flex" gap={2} marginY={2}>
              <GenericInput
                textFieldInputProps={{
                  style: {flex:0.6},
                  fullWidth: true,
                  label: "Profile Name",
                  value: profileName,
                  disabled: props.modalState === 'edit',
                  onChange: (e) => setProfileName(e.target.value),
                }}
              />
              <GenericInput
                textFieldInputProps={{
                  style:{flex:0.4},
                  fullWidth: true,
                  label: "Profile Type",
                  value: props.mediaProfileConfig.type,
                  disabled: true,
                }}
              />
              <Button color={"info"} variant="contained" className="navigation-btn" 
                onClick={()=>handleSave()
              }>Save</Button>
            </Box>
            <Divider/>
            {Object.keys(attributes).map((key:string,idx:number)=>
              <Box key={idx} display={"flex"} alignItems={"center"} marginY={2} columnGap={2}>
                <GenericInput
                  textFieldInputProps={{
                    fullWidth: true,
                    label: "Attribute Key",
                    value: key,
                    onChange: (e) => handleChangeKey(key,e.target.value),
                  }}
                />
                <GenericInput
                  textFieldInputProps={{
                    fullWidth: true,
                    label: "Attribute Value",
                    value: attributes[key],
                    onChange: (e) => handleChangeValue(key,e.target.value),
                  }}
                />
                <Button variant="contained" size="small" color="error" className="navigation-btn" 
                  style={{ minWidth: "30px", height: "30px", padding: "0 important" }}
                  onClick={()=>handleDeleteKey(key)}>
                    <Trash width={22} height={25} />
                </Button>
              </Box>
            )}
            <Button color="warning" variant="contained" className="navigation-btn" onClick={()=>handleAddRow()}>Add</Button>
          </Box>
      </Modal>
    )
}